import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=30f81b6b&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=30f81b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f81b6b",
  null
  
)

export default component.exports